export const themeJsonLight = {
  themeName: 'custom',
  colorPalette: 'light',
  isPanelless: false,
  backgroundImage: '',
  backgroundOpacity: 1,
  backgroundImageAttachment: 'scroll',
  backgroundImageFit: 'cover',
  cssVariables: {
    '--sjs-font-pagetitle-color': '#183744',
    '--sjs-font-pagedescription-color': '#183744CC',
    '--sjs-font-questiontitle-color': '#183744',
    '--sjs-general-forecolor-light': '#183744CC',
    '--sjs-editorpanel-backcolor': '#FFFFFF80',
    '--sjs-editorpanel-cornerRadius': '24px',
    '--sjs-questionpanel-cornerRadius': '16px',
    '--sjs-corner-radius': '40px',
    '--sjs-base-unit': '8px',
    '--sjs-shadow-small': '0px 4px 8px 0px rgba(0, 0, 0, 0.2)',
    '--sjs-shadow-inner': 'inset 0px 0px 0px 2px #FF1C72',
    '--sjs-shadow-inner-reset': 'inset 0px 0px 0px 2px #FF1C72',
    '--sjs-border-default': 'rgba(0, 0, 0, 0.16)',
    '--sjs-border-light': 'rgba(0, 0, 0, 0.09)',
    '--sjs-general-backcolor': '#FFFFFF80',
    '--sjs-general-backcolor-dark': '#F2F4FA',
    '--sjs-general-backcolor-dim-light': '#FFFFFF',
    '--sjs-general-backcolor-dim-dark': '#F2F4FA',
    '--sjs-general-forecolor': '#183744CC',
    '--sjs-general-dim-forecolor': '#183744',
    '--sjs-general-dim-forecolor-light': '#18374480',
    '--sjs-secondary-backcolor': '#C67D30',
    '--sjs-secondary-backcolor-light': 'rgba(198, 125, 48, 0.1)',
    '--sjs-secondary-backcolor-semi-light': 'rgba(198, 125, 48, 0.25)',
    '--sjs-secondary-forecolor': '#FFFFFF',
    '--sjs-secondary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
    '--sjs-primary-backcolor': '#FF1C72',
    '--sjs-primary-backcolor-dark': '#CC165B',
    '--sjs-primary-backcolor-light': 'rgba(255, 28, 114, 0.1)',
    '--sjs-primary-forecolor': '#FFFFFF',
    '--sjs-primary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
    '--sjs-special-red': '#CF2E2E',
    '--sjs-special-red-light': 'rgba(207, 46, 46, 0.1)',
    '--sjs-special-red-forecolor': '#FFFFFF',
    '--sjs-special-green': '#49A62D',
    '--sjs-special-green-light': 'rgba(73, 166, 45, 0.1)',
    '--sjs-special-green-forecolor': '#FFFFFF',
    '--sjs-special-blue': '#4477FF',
    '--sjs-special-blue-light': 'rgba(68, 119, 255, 0.1)',
    '--sjs-special-blue-forecolor': '#FFFFFF',
    '--sjs-special-yellow': '#FFC72C',
    '--sjs-special-yellow-light': 'rgba(255, 199, 44, 0.1)',
    '--sjs-special-yellow-forecolor': '#FFFFFF',
  },
  headerView: 'basic',
}